import { defineTransform } from '@client/core/data/concerns/parses-from-json';
import { Nullable } from '@client/core/data/types';
import { asset } from '@client/core/utils/asset';
import { isNullOrUndefined } from '@client/core/utils/is-null-or-undefined';

/**
 * @see app/Http/Resources/User/UserResource.php
 */
export class User {
  constructor(
    public readonly id: number,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly email: string,
    public readonly name: string,
    // URL to image of User
    public readonly avatar: Nullable<string>,
    public readonly hasCustomAvatar: boolean,
    public readonly isDeleted = false,
  ) {}

  get initials(): string {
    const first = this.firstName.charAt(0);
    const last = this.lastName.charAt(0);

    return (first + last).toUpperCase();
  }
}

defineTransform(User, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
    avatar: isNullOrUndefined(json.avatar) ? asset('/images/placeholders/user.png') : json.avatar,
    hasCustomAvatar: !isNullOrUndefined(json.avatar),
    isDeleted: json.is_deleted ?? false,
  };
});
